<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-arrowright`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.03015 4.58839C6.77043 4.32903 6.34931 4.3288 6.08973 4.58839C5.8306 4.84802 5.83051 5.26925 6.08973 5.52882L7.03015 4.58839ZM6.08973 11.2876C6.34915 11.547 6.77041 11.5464 7.03015 11.2876L9.69715 8.62062C10.0505 8.26727 10.0728 7.70765 9.76355 7.32863L9.69715 7.25538L7.03015 4.58839L6.56043 5.05909L6.08973 5.52882L8.4989 7.938L6.08973 10.3462C5.83044 10.6059 5.83016 11.028 6.08973 11.2876Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineArrowright',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
